import lodash from 'lodash';
export function generateId(prefix = ''): string {
  const key = Math.random().toString(36).substr(2, 5);

  return `${key}${lodash.uniqueId(prefix)}`;
}
